import script from "./central-control.vue?vue&type=script&lang=ts&setup=true"
export * from "./central-control.vue?vue&type=script&lang=ts&setup=true"

import "./central-control.vue?vue&type=style&index=0&id=719dd85e&lang=scss&scoped=true"
import "./central-control.vue?vue&type=style&index=1&id=719dd85e&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-719dd85e"]])

export default __exports__